/* =========================================================
   AIELLO PDP — interactions
   - Variant reactivity (cross-section via custom event)
   - Parcelamento 12x sem juros + Pix 8% off dinamicos
   - CEP / frete (placeholder ate Mandae)
   - Calculadora inline
   - DataLayer events (view_item, select_variant, add_to_cart)
   - Reaproveita Dawn <product-info> / <product-form> / PUB_SUB_EVENTS
   ========================================================= */

(function () {
  'use strict';

  /* ===========================================================
     Util
     =========================================================== */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
  function formatBRL(cents) {
    if (cents == null || isNaN(cents)) return '';
    return BRL.format(cents / 100);
  }

  /* ===========================================================
     Variant state (cross-section bus)
     - Ouve o PubSub do Dawn quando disponivel
     - Emite 'aiello:variant:change' no document com detalhe da variante
     - Atualiza data-attr no <body> para CSS condicional
     =========================================================== */
  function inferControlType(variant, product) {
    if (!variant || !product) return null;
    var idx = -1;
    (product.options || []).forEach(function (opt, i) {
      if ((opt || '').toLowerCase() === 'controle') idx = i;
    });
    if (idx === -1) return null;
    var raw = (variant.options || [])[idx] || '';
    var v = raw.toLowerCase();
    if (v.indexOf('wifi') !== -1 || v.indexOf('wi-fi') !== -1 || v.indexOf('timer') !== -1) return 'wifi';
    return 'botao';
  }

  function inferInstallationType(variant, product) {
    if (!variant || !product) return null;
    var idx = -1;
    (product.options || []).forEach(function (opt, i) {
      var lo = (opt || '').toLowerCase();
      if (lo === 'instalação' || lo === 'instalacao' || lo === 'installation') idx = i;
    });
    if (idx === -1) return null;
    var raw = (variant.options || [])[idx] || '';
    var v = raw.toLowerCase();
    if (v.indexOf('oculto') !== -1) return 'oculto';
    return 'aparente';
  }

  function broadcastVariant(variant, product, sectionId) {
    if (!variant) return;
    var control = inferControlType(variant, product);
    var install = inferInstallationType(variant, product);
    document.body.setAttribute('data-aiello-variant-control', control || 'botao');
    document.body.setAttribute('data-aiello-variant-id', variant.id);
    if (install) document.body.setAttribute('data-aiello-installation', install);
    document.dispatchEvent(new CustomEvent('aiello:variant:change', {
      detail: { variant: variant, product: product, controlType: control, installType: install, sectionId: sectionId }
    }));
  }

  /* ===========================================================
     Lado do Fio: forca default quando Instalacao = Fio Oculto
     (Fio oculto e ambidestro, entao escolhe o primeiro lado disponivel
     pra garantir que a variante sempre resolva pra uma combinacao valida)
     =========================================================== */
  function syncLadoDoFio(installType) {
    if (installType !== 'oculto') return;
    var ladoPickers = $$('.aiello-pd__picker--lado');
    ladoPickers.forEach(function (picker) {
      var radios = $$('input[type="radio"]', picker);
      if (!radios.length) return;
      var anyChecked = radios.some(function (r) { return r.checked; });
      // Sempre forca o primeiro radio quando muda pra oculto
      // (garante que a variante resolva pra um SKU valido,
      //  ja que pode nao haver variantes oculto/direito)
      var first = radios[0];
      if (!first) return;
      if (!first.checked || !anyChecked) {
        radios.forEach(function (r) { r.checked = false; });
        first.checked = true;
        first.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.name) return;
    var name = (t.name || '').toLowerCase();
    if (name.indexOf('instala') === -1) return;
    var value = (t.value || '').toLowerCase();
    if (value.indexOf('oculto') === -1) return;
    // Defer pra rodar depois que o Shopify processou a mudanca da variante
    setTimeout(function () { syncLadoDoFio('oculto'); }, 0);
  });

  function getProductFromSection(section) {
    // Procura primeiro dentro da section, depois no documento (script JSON
    // pode estar fora do <section> mas ainda na pagina)
    var raw = section.querySelector('[data-aiello-product-json]') || document.querySelector('[data-aiello-product-json]');
    if (!raw) return null;
    try { return JSON.parse(raw.textContent); } catch (_) { return null; }
  }
  function getCurrentVariantFromSection(section) {
    var raw = section.querySelector('[data-selected-variant]') || document.querySelector('[data-selected-variant]');
    if (!raw) return null;
    try { return JSON.parse(raw.textContent); } catch (_) { return null; }
  }

  /* ===========================================================
     Parcelamento + Pix
     =========================================================== */
  function renderPriceBreakdown(variant, scope) {
    if (!variant) return;
    var priceEl = $('[data-aiello-price]', scope);
    var comparePriceEl = $('[data-aiello-compare-price]', scope);
    var parcEl = $('[data-aiello-parcelamento]', scope);
    var pixEl = $('[data-aiello-pix]', scope);

    var price = variant.price; // cents
    var compare = variant.compare_at_price; // cents or null

    if (priceEl) priceEl.textContent = formatBRL(price);
    if (comparePriceEl) {
      if (compare && compare > price) {
        comparePriceEl.textContent = formatBRL(compare);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }
    if (parcEl) {
      var parcela = Math.round(price / 6);
      parcEl.textContent = formatBRL(parcela);
    }
    if (pixEl) {
      var pix = Math.round(price * 0.92);
      pixEl.textContent = formatBRL(pix);
    }
  }

  /* ===========================================================
     Selo "AVISE-ME" (variante sem estoque)
     =========================================================== */
  function renderStockState(variant, scope) {
    var available = variant && variant.available;
    var buyBtn = $('[data-aiello-buy-btn]', scope);
    var notifyWrap = $('[data-aiello-notify-wrap]', scope);
    if (buyBtn) {
      buyBtn.disabled = !available;
      buyBtn.textContent = available
        ? buyBtn.getAttribute('data-text-available') || 'Adicionar ao carrinho'
        : buyBtn.getAttribute('data-text-soldout') || 'Esgotado';
    }
    if (notifyWrap) notifyWrap.hidden = !!available;
  }

  /* ===========================================================
     CEP / frete — placeholder usando /cart/shipping_rates.json
     (Quando Mandae estiver ativo, basta trocar o endpoint)
     =========================================================== */
  function initShippingEstimator(scope) {
    var form = $('[data-aiello-cep-form]', scope);
    if (!form) return;
    var input = $('[data-aiello-cep-input]', form);
    var result = $('[data-aiello-cep-result]', scope);
    var loading = $('[data-aiello-cep-loading]', scope);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cep = (input.value || '').replace(/\D/g, '');
      if (cep.length !== 8) {
        result.textContent = 'CEP invalido. Use 8 digitos.';
        result.hidden = false;
        return;
      }
      result.hidden = true;
      if (loading) loading.hidden = false;

      // Estrategia: usar Shopify shipping_rates exige item no cart.
      // Por enquanto: lookup do CEP via ViaCEP + mensagem placeholder.
      fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (loading) loading.hidden = true;
          if (data.erro) {
            result.textContent = 'CEP nao encontrado.';
          } else {
            result.innerHTML = '<strong>Entrega para ' + (data.localidade || '') + '/' + (data.uf || '') + ':</strong><br>' +
              'Frete gratis - prazo de 5 a 10 dias uteis.';
          }
          result.hidden = false;
        })
        .catch(function () {
          if (loading) loading.hidden = true;
          result.textContent = 'Nao foi possivel consultar agora. Tente novamente.';
          result.hidden = false;
        });
    });

    // Mascara CEP
    if (input) {
      input.addEventListener('input', function () {
        var v = input.value.replace(/\D/g, '').slice(0, 8);
        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
        input.value = v;
      });
    }
  }

  /* ===========================================================
     Calculadora inline — 3 perguntas
     =========================================================== */
  function initCalculator(section) {
    var form = $('[data-aiello-calc-form]', section);
    if (!form) return;
    var resultBox = $('[data-aiello-calc-result]', section);
    var resultModel = $('[data-aiello-calc-model]', section);
    var resultCta = $('[data-aiello-calc-cta]', section);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var size = form.querySelector('input[name="aiello-calc-size"]:checked');
      var towels = form.querySelector('input[name="aiello-calc-towels"]:checked');
      var smart = form.querySelector('input[name="aiello-calc-smart"]:checked');
      if (!size || !towels || !smart) {
        return;
      }
      var sizeVal = size.value;          // pequeno | medio | grande
      var towelsVal = parseInt(towels.value, 10); // 1 | 2 | 4
      var smartVal = smart.value;         // sim | nao

      // Logica simples de recomendacao:
      // - 1 toalha: Uno
      // - 2 toalhas: Duo (se smart=sim, Duo Wifi)
      // - 4 toalhas / banheiro grande: Slim (se smart=sim, Slim Wifi)
      // - Banheiro medio + design statement: Solo
      var modelName = 'Duo';
      var modelHandle = 'duo';
      if (towelsVal === 1) {
        modelName = 'Uno';
        modelHandle = 'uno';
      } else if (towelsVal === 2 && sizeVal === 'medio' && smartVal === 'nao') {
        modelName = 'Solo';
        modelHandle = 'solo';
      } else if (towelsVal === 2) {
        modelName = smartVal === 'sim' ? 'Duo Wifi' : 'Duo';
        modelHandle = 'duo';
      } else if (towelsVal === 4) {
        modelName = smartVal === 'sim' ? 'Slim Wifi' : 'Slim';
        modelHandle = 'slim';
      }

      if (resultModel) resultModel.textContent = modelName;
      if (resultCta) {
        resultCta.href = '/products/' + modelHandle + (smartVal === 'sim' ? '?variant_control=wifi' : '');
        resultCta.textContent = 'Ver ' + modelName + ' →';
      }
      if (resultBox) resultBox.hidden = false;
    });
  }

  /* ===========================================================
     Galeria PDP (sticky + thumbs + lightbox + video nativo)
     =========================================================== */
  function initGallery(section) {
    var main = $('[data-aiello-pd-main-media]', section);
    if (!main) return;
    var slides = $$('[data-aiello-pd-slide]', section);
    var thumbs = $$('[data-aiello-pd-thumb]', section);
    var prevBtn = $('[data-aiello-pd-prev]', section);
    var nextBtn = $('[data-aiello-pd-next]', section);

    function go(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        // pausa videos nao-ativos
        if (i !== idx) {
          var v = s.querySelector('video');
          if (v) { try { v.pause(); } catch (_) {} }
        }
      });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      main.setAttribute('data-aiello-pd-idx', String(idx));
    }

    // Exibe apenas a miniatura 3D correspondente ao slide de modelo ativo
    function syncModelThumb(slideIdx) {
      var targetId = slides[slideIdx] ? slides[slideIdx].getAttribute('data-aiello-media-id') : null;
      thumbs.forEach(function (t) {
        if (t.getAttribute('data-aiello-media-type') !== 'model') return;
        var match = targetId && t.getAttribute('data-aiello-media-id') === targetId;
        t.classList.toggle('is-model-visible', !!match);
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(i); }
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      var i = parseInt(main.getAttribute('data-aiello-pd-idx') || '0', 10);
      go(i - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var i = parseInt(main.getAttribute('data-aiello-pd-idx') || '0', 10);
      go(i + 1);
    });

    // Variant change: troca para a slide correspondente à variante
    // 1) Modelo 3D especifico (cor+instalacao+lado+timer) — prioridade
    // 2) Fallback: foto destacada por cor (featured_media)
    document.addEventListener('aiello:variant:change', function (e) {
      var v = e.detail.variant;
      if (!v) return;

      // Tentativa 1: modelo 3D especifico (cor+instalacao+lado+timer) — PRIORIDADE sobre a foto,
      // que e generica por cor (uma so por cor; nao reflete instalacao/controle).
      var COLOR_NORM_3D = {
        'preto fosco': 'preto_fosco',
        'preto':       'preto_fosco',
        'branco':      'branco',
        'cromado':     'cromado',
        'inox escovado': 'inox_escovado',
        'inox polido':   'inox_polido',
        'dourado brilho': 'dourado',
        'dourado polido': 'dourado',
        'dourado fosco':  'dourado',
        'dourado escovado': 'dourado',
      };
      var opts = (v.options || []).map(function (o) { return (o || '').toLowerCase(); });
      var joined = opts.join(' ');

      var colorKey = '';
      Object.keys(COLOR_NORM_3D).forEach(function (raw) {
        if (!colorKey && joined.indexOf(raw) !== -1) colorKey = COLOR_NORM_3D[raw];
      });

      var installKey = '';
      if (joined.indexOf('oculto') !== -1) installKey = 'oculto';
      else if (joined.indexOf('aparente') !== -1) installKey = 'aparente';

      var sideKey = '';
      if (joined.indexOf('esquerdo') !== -1) sideKey = 'esquerdo';
      else if (joined.indexOf('direito') !== -1) sideKey = 'direito';

      var timerKey = (joined.indexOf('wi-fi') !== -1 || joined.indexOf('wifi') !== -1 || joined.indexOf('timer') !== -1) ? 'timer' : '';

      function findModelSlide(requireInstall, requireTimer) {
        return slides.findIndex(function (s) {
          if (s.getAttribute('data-aiello-media-type') !== 'model') return false;
          var key = (s.getAttribute('data-aiello-model-key') || '').toLowerCase();
          var colorOk   = key.indexOf(colorKey) !== -1;
          // 'oculto' = ausencia do token 'aparente' (cobre GLBs sem o token 'oculto', ex.: Classic Duo)
          var installOk = (!requireInstall || !installKey)
            ? true
            : (installKey === 'oculto' ? key.indexOf('aparente') === -1 : key.indexOf(installKey) !== -1);
          var sideOk    = !sideKey || key.indexOf(sideKey) !== -1;
          var timerOk   = !requireTimer || (timerKey ? key.indexOf('_timer') !== -1 : key.indexOf('_timer') === -1);
          return colorOk && installOk && sideOk && timerOk;
        });
      }

      // 1) exato (cor+instalação+lado+timer)  2) ignora timer  3) só cor+lado
      if (colorKey) {
        var byModel = findModelSlide(true, true);
        if (byModel < 0) byModel = findModelSlide(true, false);
        if (byModel < 0) byModel = findModelSlide(false, false);
        if (byModel >= 0) { go(byModel); syncModelThumb(byModel); return; }
      }

      // Tentativa 2 (fallback): foto destacada por cor (featured_media; featured_image NAO casa o id).
      var featMedia = v.featured_media || v.featured_image;
      if (featMedia && featMedia.id) {
        var byId = slides.findIndex(function (s) {
          return s.getAttribute('data-aiello-media-id') === String(featMedia.id);
        });
        if (byId >= 0) { go(byId); syncModelThumb(-1); return; }
      }
      syncModelThumb(-1);
    });

    // Sync inicial: dispara com a variante já selecionada ao carregar a página
    (function () {
      var initData = document.querySelector('[data-aiello-product-json]');
      if (!initData) return;
      try {
        var pData = JSON.parse(initData.textContent);
        var initVariant = pData.selected_or_first_available_variant || (pData.variants && pData.variants[0]);
        if (initVariant) {
          document.dispatchEvent(new CustomEvent('aiello:variant:change', { detail: { variant: initVariant } }));
        }
      } catch (_) {}
    })();

    // Lightbox
    var lb = $('[data-aiello-pd-lb]', section);
    if (!lb) return;
    var lbImg = $('[data-aiello-pd-lb-img]', lb);
    var lbVideo = $('[data-aiello-pd-lb-video]', lb);
    var lbClose = $('[data-aiello-pd-lb-close]', lb);
    var lastTrigger = null;

    function openLb(slide) {
      lastTrigger = document.activeElement;
      var type = slide.getAttribute('data-aiello-media-type');
      if (type === 'video') {
        var src = slide.getAttribute('data-aiello-video-src');
        if (lbVideo && src) {
          lbVideo.src = src;
          lbVideo.hidden = false;
          if (lbImg) lbImg.hidden = true;
          try { lbVideo.play(); } catch (_) {}
        }
      } else {
        var bigSrc = slide.getAttribute('data-aiello-zoom-src') || (slide.querySelector('img') || {}).src;
        if (lbImg && bigSrc) {
          lbImg.src = bigSrc;
          lbImg.hidden = false;
          if (lbVideo) { lbVideo.hidden = true; try { lbVideo.pause(); } catch (_) {} lbVideo.removeAttribute('src'); }
        }
      }
      lb.hidden = false;
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (lbClose) lbClose.focus(); }, 50);
    }
    function closeLb() {
      lb.classList.remove('is-open');
      lb.hidden = true;
      document.body.style.overflow = '';
      if (lbVideo) { try { lbVideo.pause(); } catch (_) {} lbVideo.removeAttribute('src'); lbVideo.hidden = true; }
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }

    slides.forEach(function (slide) {
      if (slide.getAttribute('data-aiello-media-type') === 'model') return;
      slide.addEventListener('click', function () { openLb(slide); });
    });
    if (lbClose) lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
    });
  }

  /* ===========================================================
     Disponibilidade do seletor "Controle"
     - Se o produto nao tem opcao "Controle", o seletor ja nao
       sera renderizado (controlado em Liquid).
     - Se opcao "Controle" + variante atual nao disponivel,
       marcar disabled visualmente.
     =========================================================== */
  function refreshControlAvailability(product, scope) {
    if (!product) return;
    var inputs = $$('[data-aiello-control-option] input', scope);
    inputs.forEach(function (input) {
      var optionValue = input.value;
      // Encontra qualquer variante com esse valor de controle
      var match = (product.variants || []).find(function (v) {
        return (v.options || []).indexOf(optionValue) !== -1;
      });
      if (match) {
        input.disabled = !match.available;
        var label = input.closest('label');
        if (label) label.classList.toggle('is-disabled', !match.available);
      }
    });
  }

  /* ===========================================================
     Cards comparativos de Controle — atualiza preco + diff
     em cada card a partir das selecoes atuais de Cor/Instalacao.
     =========================================================== */
  function updateControlPrices(scope, product) {
    if (!product) return;
    var wrap = scope.querySelector('[data-aiello-ctrl-wrap]');
    if (!wrap) return;

    var optionNames = product.options || [];
    var ctrlIdx = -1;
    optionNames.forEach(function (n, i) {
      if ((n || '').toLowerCase().trim() === 'controle') ctrlIdx = i;
    });
    if (ctrlIdx === -1) return;

    // Coleta selecoes atuais (exceto controle)
    var otherSels = {};
    $$('fieldset.aiello-pd__picker', scope).forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var m = checked.name.match(/options\[(.+)\]/);
      if (!m) return;
      var opt = m[1];
      if (opt.toLowerCase().trim() !== 'controle') {
        otherSels[opt] = checked.value;
      }
    });

    // Encontra variantes Botao e Wifi que casam com otherSels
    var botaoVariant = null;
    var wifiVariant = null;
    (product.variants || []).forEach(function (v) {
      var matchesOthers = optionNames.every(function (opt, i) {
        if (i === ctrlIdx) return true;
        return otherSels[opt] === (v.options || [])[i];
      });
      if (!matchesOthers) return;
      var ctrlValueLow = ((v.options || [])[ctrlIdx] || '').toLowerCase();
      var isWifi = ctrlValueLow.indexOf('wifi') !== -1 || ctrlValueLow.indexOf('wi-fi') !== -1 || ctrlValueLow.indexOf('timer') !== -1;
      if (isWifi) wifiVariant = v;
      else botaoVariant = v;
    });

    var botaoPriceEl = wrap.querySelector('[data-aiello-ctrl-price="botao"]');
    var wifiPriceEl = wrap.querySelector('[data-aiello-ctrl-price="wifi"]');
    var diffEl = wrap.querySelector('[data-aiello-ctrl-diff]');

    if (botaoVariant && botaoPriceEl) botaoPriceEl.textContent = formatBRL(botaoVariant.price);
    if (wifiVariant && wifiPriceEl) wifiPriceEl.textContent = formatBRL(wifiVariant.price);

    if (diffEl) {
      if (botaoVariant && wifiVariant) {
        var diff = wifiVariant.price - botaoVariant.price;
        if (diff > 0) {
          diffEl.textContent = '+' + formatBRL(diff);
          diffEl.hidden = false;
        } else {
          diffEl.hidden = true;
        }
      } else {
        diffEl.hidden = true;
      }
    }
  }

  /* ===========================================================
     dataLayer push (GTM-ready, sem dependencia)
     =========================================================== */
  function pushDataLayer(eventName, variant, product) {
    if (!variant || !product) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: 'BRL',
        items: [{
          item_id: String(variant.id),
          item_name: product.title,
          item_variant: (variant.options || []).join(' / '),
          item_brand: 'Aiello',
          item_category: product.type || 'Toalheiro',
          price: (variant.price || 0) / 100
        }]
      }
    });
  }

  /* ===========================================================
     Quantity controls (+/-)
     =========================================================== */
  function initQuantityControls(scope) {
    var input = $('.aiello-pd__qty input[name="quantity"]', scope);
    var dec = $('[data-aiello-qty-dec]', scope);
    var inc = $('[data-aiello-qty-inc]', scope);
    if (!input) return;
    function setVal(n) {
      var min = parseInt(input.min || '1', 10);
      var max = parseInt(input.max || '99', 10);
      if (n < min) n = min;
      if (n > max) n = max;
      input.value = String(n);
    }
    if (dec) dec.addEventListener('click', function () { setVal(parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { setVal(parseInt(input.value, 10) + 1); });
  }

  /* ===========================================================
     Variant picker — handler proprio (substitui Dawn <variant-selects>)
     - Ouve change em todos os radios [name^="options["]
     - Encontra variante que casa com selecoes atuais
     - Atualiza: hidden input id, URL ?variant=, JSON data-selected-variant,
       legend [data-selected-value], price/parc/pix/sku/stock, body data-attr
     =========================================================== */
  function initVariantPicker(section, product) {
    if (!product) return;
    var idInput = section.querySelector('[data-aiello-variant-id-input]');
    var inputs = $$('input[type="radio"][name^="options["]', section);
    var jsonScript = section.querySelector('[data-selected-variant]');

    function getSelections() {
      var selections = {};
      $$('fieldset.aiello-pd__picker', section).forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        var m = checked.name.match(/options\[(.+)\]/);
        if (m) selections[m[1]] = checked.value;
      });
      return selections;
    }

    function findVariant(selections) {
      var optionNames = product.options || [];
      return (product.variants || []).find(function (v) {
        return optionNames.every(function (optName, i) {
          return selections[optName] === (v.options || [])[i];
        });
      });
    }

    function updateLegend(fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var label = fieldset.querySelector('[data-selected-value]');
      if (checked && label) label.textContent = checked.value;
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      // URL update
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (_) {}

      // Update JSON
      if (jsonScript) {
        try { jsonScript.textContent = JSON.stringify(variant); } catch (_) {}
      }

      broadcastVariant(variant, product, section.id);
      renderPriceBreakdown(variant, section);
      renderStockState(variant, section);
      refreshControlAvailability(product, section);
      updateControlPrices(section, product);
      pushDataLayer('select_variant', variant, product);
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function (e) {
        var fs = e.target.closest('fieldset.aiello-pd__picker');
        if (fs) updateLegend(fs);
        var selections = getSelections();
        var v = findVariant(selections);
        applyVariant(v);
      });
    });
  }

  /* ===========================================================
     Init — section aiello-product-main
     =========================================================== */
  function initProductMain(section) {
    if (section.__aielloPDInit) return;
    section.__aielloPDInit = true;

    var product = getProductFromSection(section);
    var variant = getCurrentVariantFromSection(section);

    if (variant) {
      broadcastVariant(variant, product, section.id);
      renderPriceBreakdown(variant, section);
      renderStockState(variant, section);
      refreshControlAvailability(product, section);
      updateControlPrices(section, product);
      pushDataLayer('view_item', variant, product);
    }

    initVariantPicker(section, product);
    initGallery(section);
    initShippingEstimator(section);
    initQuantityControls(section);

    // Submit do form -> dispara add_to_cart
    var form = section.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener('submit', function () {
        var v = getCurrentVariantFromSection(section);
        pushDataLayer('add_to_cart', v, product);
      });
    }

    // Notify-me submit (placeholder ate Klaviyo)
    var notifyForm = $('[data-aiello-notify-form]', section);
    if (notifyForm) {
      notifyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = $('[data-aiello-notify-msg]', section);
        if (msg) {
          msg.textContent = 'Tudo certo! Vamos te avisar assim que voltar ao estoque.';
          msg.hidden = false;
        }
        // TODO: integrar Klaviyo Back-in-Stock quando disponivel
      });
    }
  }

  /* ===========================================================
     Bootstrap
     =========================================================== */
  function bootstrap() {
    $$('[data-aiello-product-main]').forEach(initProductMain);
    $$('[data-aiello-calculator]').forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Theme Editor re-init
  document.addEventListener('shopify:section:load', bootstrap);
})();
